module.exports = "/_next/static/images/nowwallet-logo-da3893f69939ba8dfad399b6658cdc09.svg";